import React from 'react';
import { HtmlWithLinks } from '../HtmlWithLinks/HtmlWithLinks';
import * as S from './EnrollBanner.styled';
export const Root = ({ children }) => React.createElement(S.Container, null, children);
export const Title = ({ children }) => React.createElement(S.Title, null, children);
export const Description = ({ children }) => (React.createElement(S.Description, null,
    React.createElement(HtmlWithLinks, { html: children })));
export const Actions = ({ children }) => (React.createElement(S.ButtonsContainer, null, children));
export const Content = ({ children }) => React.createElement(S.Content, null, children);
